import { createAction, createAsyncAction } from 'typesafe-actions';
import { VariantsModel } from './types';

export const FETCH_VARIANTS = createAsyncAction(
  'product/FETCH_VARIANTS/request',
  'product/FETCH_VARIANTS/success',
  'product/FETCH_VARIANTS/failure',
  'product/FETCH_VARIANTS/cancel',
)<void, VariantsModel, Error, void>();

export const RESET_VARIANTS = createAction('product/RESET_VARIANTS')();
